module.exports = __webpack_public_path__ + "static/media/Twitch.f853d73d.png";